import { forwardRef } from 'react';
import type { InputHTMLAttributes } from 'react';
import styles from './FormInput.module.css';

export interface FormInputProps extends InputHTMLAttributes<HTMLInputElement> {
	hasError?: boolean;
	suffix?: string;
}

export const FormInput = forwardRef<HTMLInputElement, FormInputProps>(
	({ hasError, className, suffix, ...props }, ref) => {
		if (!suffix) {
			return (
				<input
					ref={ref}
					className={`${styles.input} ${hasError ? styles.error : ''} ${className ?? ''}`}
					{...props}
				/>
			);
		}
		return (
			<div className={styles.wrapper}>
				<input
					ref={ref}
					className={`${styles.input} ${styles.hasSuffix} ${hasError ? styles.error : ''} ${className ?? ''}`}
					{...props}
				/>
				<span className={styles.suffix}>{suffix}</span>
			</div>
		);
	},
);

FormInput.displayName = 'FormInput';
